<template>
  <div class="file-man">
    <!-- 面包屑 -->
    <Breadcrumb :crumb="crumb" />
    <div class="contain">
      <div v-if="!isEdit">
        <!-- 搜索 -->
        <div class="top clearfix">
          <div class="fl">
            菜单：<el-select v-model="scoreMenuValue" filterable clearable @change="getHttp(1)" placeholder="请选择"
                       size="small">
              <el-option v-for="item in scoreMenuList" :key="item.menuCode" :label="item.menuName"
                         :value="item.menuCode">
              </el-option>
            </el-select>
            积分：<el-input class="score-input" type="text" v-model="scoreValue" @change="inputChange" size="small"
                      placeholder="请输入关键字"></el-input>
            搜索：<el-input type="text" class="score-input" v-model="keyWord" @change="inputChange" size="small"
                      placeholder="请输入关键字"></el-input>
          </div>

          <div class="fr">
            <el-button size="small" icon="iconfont icon-add" @click="showAddPop">新增菜单</el-button>
          </div>

        </div>
        <!-- 表格 -->
        <el-table :data="tableData" stripe style="width: 100%" :header-cell-style="{ background: '#EFEFEF' }">
          <el-table-column prop="integralModelDesc" label="菜单" width="150">
          </el-table-column>
          <el-table-column prop="integralName" label="类型" width="440">
          </el-table-column>
          <el-table-column prop="integralNum" label="积分" width="80">
          </el-table-column>
          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <el-button type="text" class="text-edit" @click="showEdit(scope.$index, scope.row)">编辑</el-button>|
              <el-button type="text" class="text-del" @click="showDelPop(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="updateTime" label="更新时间">
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <pagination :pageObj="pageObj" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
        </pagination>
      </div>
      <!-- 编辑 -->
      <div v-else>
        <IntegralRuleEdit @closeEdit="closeEdit" :isAddMenu="isAddMenu" :addMenuObj="addMenuObj"
                          :selectRow="selectRow" />
      </div>

    </div>

    <!-- 删除的对话框 -->
    <popup-del :delVisible="delVisible" @close="closePopupDel"></popup-del>

    <!-- 新增的对话框 -->
    <el-dialog class="add-pop" title="新增" :visible.sync="addVisible" :close-on-click-modal="false" width="400px"
               top="20%">
      <template v-slot:title>
        <div class="add-title">新 增</div>
      </template>
      <template>
        请选择菜单：<el-select v-model="addMenuCode" placeholder="请选择">
          <el-option v-for="item in scoreMenuList" :key="item.menuCode" :label="item.menuName" :value="item.menuCode">
          </el-option>
        </el-select>
      </template>

      <template v-slot:footer>
        <span class="dialog-footer">
          <el-button @click="submitStudent" type="primary">提 交</el-button>
        </span>
      </template>
    </el-dialog>
  </div>

</template>

<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import PopupDel from "@/components/PopupDel.vue";
import Pagination from "@/components/Pagination.vue";
import IntegralRuleEdit from "@/views/home/menu/SysManagement/IntegralRuleEdit.vue";
import { mapState } from "vuex";

export default {
  components: {
    Breadcrumb,
    PopupDel,
    IntegralRuleEdit,
    Pagination,
  },
  computed: {
    ...mapState(["scoreMenuList", "userInfo",'isAdmin']),
  },
  data() {
    return {
      value: "",
      //面包屑
      crumb: {
        list: ["系统管理", "积分管理"],
        //titBig:"默认为list最后一位，也可更改"
      },
      isEdit: false,
      scoreMenuValue: "",
      addMenuCode: "",
      addMenuObj: null,
      delVisible: false,
      addVisible: false,
      scoreValue: "",
      keyWord: "",

      rules: {
        xuenian: [
          {
            required: true,
            message: "请选择学年",
            trigger: ["change", "blur"],
          },
        ],
        prizeName: [
          {
            required: true,
            message: "请输入获奖名称",
            trigger: ["change", "blur"],
          },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: ["change", "blur"],
          },
        ],
        studentName: [
          {
            required: true,
            message: "请输入获奖学生",
            trigger: ["change", "blur"],
          },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: ["change", "blur"],
          },
        ],
        enclosure: [
          {
            required: true,
            message: "请选择附件",
            trigger: ["change", "blur"],
          },
        ],
        email: [
          {
            type: "email",
            message: "请输入正确的邮箱",
            trigger: ["change", "blur"],
          },
        ],
        mobile: [
          {
            pattern: /^1[1-9]\d{9}$/,
            message: "请输入正确的手机号",
            trigger: ["change", "blur"],
          },
        ],
      },
      tableData: [],
      selectRow: null,

      //子组件接受，是否是第一次新增的菜单
      isAddMenu: false,

      pageObj: {
        current: 1,
        total: 0,
        size: 10,
        sizeList: [10, 15, 20, 25, 30],
      },
    };
  },
  created() {
    this.getHttp(1);
  },
  methods: {
    getHttp(curPage, pageSize) {
      let selectForm = {
        schoolCode: this.userInfo.schoolCode,
        integralModel: this.scoreMenuValue || "",
        clientPackage: "com.xueduoduo.teacher.archives.pc",
        pageNum: curPage || this.pageObj.current,
        pageSize: pageSize || this.pageObj.size,
        integralNum: this.scoreValue || "",
        keyword: this.keyWord || "",
        isAdmin: this.isAdmin / 1 ,
        operatorId: this.userInfo.userId,
      };
      this.$axios
        .post("/integralRule/getTeacherIntegralRuleListByUser", selectForm)
        .then((res) => {
          if (res.resultCode === 200) {
            this.pageObj.size = res.data.size;
            this.pageObj.current = res.data.current;
            this.pageObj.total = res.data.total;
            this.tableData = res.data.records;
          } else {
            console.log("列表查询积分规则error", res);
          }
        })
        .catch((err) => {
          console.log("列表查询catch error", err);
        });
    },
    previewEnclosure() { },
    showEdit(index, row) {
      this.selectRow = row;
      this.crumb.list.push(row.integralModelDesc);
      this.isEdit = true;
    },
    closeEdit() {
      this.crumb.list.pop();
      this.isAddMenu = false;
      this.isEdit = false;
      this.getHttp(this.pageObj.current, this.pageObj.size);
    },
    inputChange() {
      this.getHttp(1);
    },
    // 删除
    showDelPop(index, row) {
      this.selectRow = row;
      this.delVisible = true;
    },
    closePopupDel(status) {
      if (status) {
        let selectForm = {
          id: this.selectRow.id,
          operatorId: this.userInfo.userId,
        };
        this.$axios
          .post("/integralRule/deleteTeacherIntegralRule", selectForm)
          .then((res) => {
            if (res.resultCode === 200) {
              this.getHttp(1, this.pageObj.size),
                this.$message({
                  message: "删除成功",
                  type: "success",
                  duration: 2000,
                  offset: 150,
                });
            } else {
              console.log("error", res);
            }
          })
          .catch((err) => {
            console.log("catch error", err);
          });

        this.delVisible = false;
      } else {
        this.delVisible = false;
      }
    },
    handleSizeChange(pageSize) {
      this.pageObj.size = pageSize;
      this.getHttp(1, pageSize);
    },
    handleCurrentChange(curPage) {
      this.getHttp(curPage);
    },

    // 新增
    showAddPop() {
      this.addVisible = true;
    },
    //新增类型 提交
    submitStudent() {
      this.addMenuObj = this.scoreMenuList.find(
        (item) => item.menuCode === this.addMenuCode
      );

      this.isAddMenu = true;

      this.crumb.list.push(this.addMenuObj.menuName);
      this.addVisible = false;
      this.isEdit = true;
    },
  },
};
</script>

<style lang="less" scoped>
.file-man {
  padding: 18px;
  border-radius: 8px;

  .contain {
    background: #fff;
    padding: 20px;
    border-radius: 20px;

    .top {
      background: #fff;
      height: 32px;
      margin-bottom: 5px;
      font-size: 15px;
      margin-bottom: 13px;

      .fl {
        box-sizing: border-box;
        width: calc(100% - 150px);
        max-width: 956px;
      }

      .el-select {
        width: 20%;
        margin-right: 20px;
      }

      .score-input {
        width: 20%;
        margin-right: 20px;
      }

      /deep/.el-input {
        width: none !important;

        .el-input__inner {
          width: none !important;
        }
      }

      .el-button {
        background: @theme-color;
        color: #fff;
        font-size: 14px;

        /deep/.iconfont {
          font-size: 15px;
          margin-right: 5px;
        }
      }

      .searchkey-input-com {
        width: 20%;
        margin-right: 2%;
      }

    }

    /deep/.el-table td,
    .el-table th {
      padding: 7px 0px;

      .text-edit {
        margin-right: 8px;
        color: @theme-color;
      }

      .text-del {
        margin-left: 5px;
        color: @warning-color;
      }
    }
  }

  /deep/.el-dialog__header {
    padding: 0px;

    .dialog-title {
      position: relative;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 10px;
      background: #f56c6c;
      border-radius: 8px 8px 0px 0px;
      margin-bottom: 45px;

      .logo {
        transform: translate(-50%, -50%);
        position: absolute;
        top: 50%;
        left: 50%;
        width: 78px;
        height: 78px;
        border-radius: 50%;
        background: #f56c6c;
        color: #fff;
        font-size: 50px;
      }
    }
  }

  .add-pop {

    // 新增对话框
    /deep/.el-dialog {
      border-radius: 10px;

      .add-title {
        border-radius: 10px 10px 0px 0px;
        text-align: center;
        font-size: 15px;
        color: #fff;
        height: 40px;
        line-height: 40px;
        background: @theme-color;
      }

      /deep/.el-dialog__headerbtn {
        top: 13px;

        i {
          color: #fff;
        }
      }

      /deep/.el-dialog__body {
        padding: 35px 55px 20px 35px;
      }

      .el-dialog__footer {
        .el-button {
          background: @theme-color;
        }
      }
    }
  }
}
</style>
